import moment from 'moment';
import { saveAs } from 'file-saver';
import { State, RequestError } from 'types';

type Payload = RequestError | ArrayBuffer | undefined;

export const saveBlob = (payload: Payload, prefix: string) => {
  const resultState: State = {
    error: 'UNKNOWN_ERROR',
    status: 'error',
  };
  if (payload) {
    const blob = new Blob([payload], {
      type: 'application/octet-stream',
    });
    saveAs(blob, `${prefix}_${moment().format('YYYY-MM-DD_HHmmss')}.xlsx`);
    resultState.error = undefined;
    resultState.status = 'success';
  }
  return resultState;
};
